import React, {useEffect, useRef, useState} from "react";
import classNames from "classnames";

type SearchNumberFieldProps = {
    placeholder?: string;
    disabled?: boolean;
    onChange: (value?: string | number) => void
    timeDelay?: number;
    minimumInput?: number;
    preventDefaultEvent?: boolean;
    additionalClasses?: string;
    initialValue?: string | number
    minVal?: number;
    maxVal?: number;
}
export const SearchNumberField = ({
                                      initialValue,
                                      onChange,
                                      timeDelay = 500,
                                      minVal,
                                      maxVal,
                                      placeholder,
                                      disabled,
                                      additionalClasses,
                                      ...props
                                  }: SearchNumberFieldProps) => {
    const [value, setValue] = useState(initialValue)
    const isFirstRun = useRef(true)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        // Skip firing onChange on initial mount so we don't reset the parent's
        // filter value (e.g. setting a range filter to [undefined, undefined]
        // which would filter out all rows).
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        const timeout = setTimeout(() => {
            onChange(value)
        }, timeDelay)
        return () => clearTimeout(timeout)
    }, [value])

    return (
        <div className={classNames('d-flex flex-grow', additionalClasses)}>
            <input
                {...props}
                className="form-control"
                type="number"
                min={minVal}
                max={maxVal}
                value={value ?? ""}
                placeholder={`${placeholder}`}
                disabled={disabled}
                onChange={(event) => setValue(event.target.value)}
            />
        </div>
    )
}
